// phone number verification
import React, { Component, createRef } from 'react';
import { Form, Input, Modal, message } from 'antd';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { tokenAction } from "../../redux-stuffs/actions/token_action";
import { accessTokenState, phoneState, loginOtpVerifyCount, loginOtpVerifyDate } from "../../atoms";
import withRecoil from '../../withRecoil';
import queryString from "query-string";
import api from '../../api/api/index';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

function error(title, content) {
  Modal.error({ title, content });
}

class EnterLoginOtp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      otp: new Array(4).fill(""),
      isResendDisabled: false,
      resendTimer: 0,
    };
    this.inputRefs = Array(4).fill().map(() => createRef());
  }

  handleChange = (e, index) => {
    const value = e.target.value;
    if (/^[0-9]{0,1}$/.test(value)) {
      const newOtp = [...this.state.otp];
      newOtp[index] = value;
      this.setState({ otp: newOtp });

      // Move to the next input field
      if (value !== "" && index < 3) {
        this.inputRefs[index + 1].current.focus();
      }
    }
  }

  handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && this.state.otp[index] === "") {
      if (index > 0) {
        this.inputRefs[index - 1].current.focus();
      }
    }
  }

  handleSubmit = () => {
    const { t } = this.props;
    const otpValue = this.state.otp.join("");
    const otpNumber = Number(otpValue);
    if (otpValue.length === 4 && otpNumber) {
      let finalBody = {
        user_otp: otpNumber,
        access_token: this.props.recoilStates.accessTokenState.state
      };
      fetch(`${api.extra}/api/verify_otp_login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
        body: queryString.stringify(finalBody)
      })
        .then(response => response.json())
        .then(res => {
          if (res.success) {
            this.props.history.push("/dashboard");
          } else {
            error(t('common:error'), res.message);
            if (this.props.recoilStates.loginOtpVerifyCount.state === undefined) {
              this.props.recoilStates[loginOtpVerifyCount.key].setState(0);
            } else {
              console.log(this.props.recoilStates.loginOtpVerifyCount.state);
            }
            let count = this.props.recoilStates.loginOtpVerifyCount.state;
            count++;
            this.props.recoilStates[loginOtpVerifyCount.key].setState(count);
            if (this.props.recoilStates.loginOtpVerifyCount.state >= 3) {
              const date = new Date();
              this.props.recoilStates[loginOtpVerifyDate.key].setState(date);
              Modal.error({
                title: t('common:error'),
                content: t('loginOtp:tooManyTries'),
                onOk: this.props.history.push("/login")
              });
            }
          }
        })
        .catch(err => {
          console.log(err.message);
          message.error(err.message);
        });
    } else {
      message.error(this.props.t('loginOtp:enterFullOtp'));
    }
  }

  handleResend = () => {
    const { t } = this.props;
    // Start the resend timer
    this.setState({ isResendDisabled: true, resendTimer: 30 });

    fetch(`${api.extra}/api/login_otp`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
      body: queryString.stringify({
        access_token: this.props.recoilStates.accessTokenState.state,
        phone: this.props.recoilStates.phoneState.state
      }),
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((errorResult) => {
            throw new Error(errorResult.message || t('loginOtp:genericError'));
          });
        }
        return response.json();
      })
      .then((res) => {
        if (res.status === 200) {
          message.success(res.message || t('loginOtp:resentSuccess'));

          const countdown = setInterval(() => {
            if (this.state.resendTimer === 0) {
              clearInterval(countdown);
              this.setState({ isResendDisabled: false });
            } else {
              this.setState((prevState) => ({
                resendTimer: prevState.resendTimer - 1,
              }));
            }
          }, 1000);
        } else {
          throw new Error(res.message || t('loginOtp:unexpectedError'));
        }
      })
      .catch((err) => {
        console.error('Error in handleResend:', err.message);
        message.error(err.message || t('loginOtp:resentFailed'));
        this.setState({ isResendDisabled: false });
      });
  };

  handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      this.handleSubmit();
    }
  };

  render() {
    const { t } = this.props;
    const lastFour = (this.props.recoilStates.phoneState.state || '').slice(-4);

    return (
      <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100vh", padding: "20px" }}>
        <div style={{position: 'relative', marginBottom: '20px', textAlign: 'center', width: '100%' }}>
          <div className='spare'>
            <h2 style={{ textAlign: "center", margin: "0" }}>{t('loginOtp:title')}</h2>
          </div>
          <div className='spare'>
            <p>
              {t('loginOtp:sentToEnding', { lastFour })} {t('loginOtp:enterBelow')}
            </p>
          </div>
        </div>

        {/* Phone Number Verification */}
        <div style={{ position: 'relative', width: '100%', textAlign: 'center' }}>
          <Form className="otp-form">
            <div className="otp-inputs">
              {this.state.otp.map((value, index) => (
                <Form.Item key={index} noStyle>
                  <Input
                    type="number"
                    inputmode="numeric"
                    maxLength="1"
                    value={value}
                    onChange={(e) => this.handleChange(e, index)}
                    onKeyDown={(e) => this.handleKeyDown(e, index)}
                    ref={this.inputRefs[index]}
                    className="otp-input"
                  />
                </Form.Item>
              ))}
            </div>
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", gap: 8 }}>
              <button type="submit" onKeyDown={this.handleKeyDown} onClick={this.handleSubmit} className="action-button btn">
                {t('loginOtp:continue')}
              </button>
                <button
                    className="action-button btn"
                    type="link"
                    disabled={this.state.isResendDisabled}
                    onClick={this.handleResend}
                >
                    {this.state.isResendDisabled
                        ? t('loginOtp:resendIn', { seconds: this.state.resendTimer })
                        : t('loginOtp:resend')}
                </button>
            </div>
          </Form>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ tokenAction }, dispatch);

const mapStateToProps = (state) => ({
  token: state.token,
  profile: state.profile,
});

// withTranslation must wrap before withRouter/withRecoil/connect on the concrete component
const Wrapped = withTranslation(['otp', 'common'])(EnterLoginOtp);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(withRecoil(Wrapped, [accessTokenState, phoneState, loginOtpVerifyCount, loginOtpVerifyDate])));
